import { ChapterDivider } from '@/components/ChapterDivider';
import { PullToUnlock } from '@/components/reader/PullToUnlock';
import { Chapter } from '@/types';

interface LockedChapterSectionProps {
  chapter: Chapter;
  bookId?: string;
  bookTitle?: string;
  pullProgress: number;
  onUnlock: () => void;
}

export function LockedChapterSection({ 
  chapter, 
  bookId, 
  bookTitle, 
  pullProgress, 
  onUnlock 
}: LockedChapterSectionProps) {
  return (
    <div className="mt-16">
      <ChapterDivider 
        chapterNumber={chapter.sequence}
        chapterTitle={chapter.title}
      />
      <PullToUnlock
        chapter={chapter}
        onUnlock={onUnlock}
        isUnlocked={false}
        teaserText="The story continues..."
        bookId={bookId}
        bookTitle={bookTitle}
        externalPullProgress={pullProgress}
      />
    </div>
  );
}
